import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import { RoleGuard } from 'client/app/guards/role.guard';
import { LicenseKeyListComponent } from './license-key-list/license-key-list.component';
import { ShareLicenseKeysFormComponent } from './share-license-keys-form/share-license-keys-form.component';
import { MyOrgBillingCodesFormComponent } from './my-org-billing-codes-form/my-org-billing-codes-form.component';
import { LicenseMultiComponent } from './license-multi/license-multi.component';
import { LicenseMultiNewComponent } from './license-multi-new/license-multi-new.component';

const routes: Routes = [
	{
		path: '',
		component: LicenseKeyListComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: 'share',
		component: ShareLicenseKeysFormComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: 'billing-codes/:orgId/new',
		component: MyOrgBillingCodesFormComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: ':id/share',
		component: ShareLicenseKeysFormComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: ':id/host/:hostid',
		component: LicenseMultiNewComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole },
		resolve: []
	},
	{
		path: ':id/snooze',
		component: LicenseMultiNewComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: ':id/snooze/edit/:snoozeid',
		component: LicenseMultiNewComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: ':id/snooze/:type',
		component: LicenseMultiNewComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	},
	{
		path: ':id',
		component: LicenseMultiNewComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole }
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class MyKeysRoutingModule { }
